/* eslint-disable camelcase */
/* global wx */
import React from 'react'
import classnames from 'classnames'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import styles from './udeskSide.module.less'
import {Form, Table, Icon, Input, Button, Spin, Tag, Modal, Popover, message, Tabs, Empty, Select} from 'antd'
import {ajaxApi, ajaxApiGet, ajaxFromdataPost} from '../../server/index'
import moment from 'moment'
import common from '../../public/common'
import _ from 'lodash'
import { getCookie, clearCookie, getParmUrl } from '@/public/utils'

import {getWxworkVersion} from './utils'
import {getUtmCampaign} from './service'
import OrderTabItem from './components/OrderTabItem'
import ProductSearchbar from './components/ProductSearchBar'
import ActivityTabItem from './components/ActivityTabItem'

const mobileReg = /^1[3-9]\d{9}$/
const confirm = Modal.confirm
const { TabPane } = Tabs
const prizeStatusMap = {
  'no_exchange': '待兑换',
  'exchanging': '兑奖中',
  'expired': '已过期',
  'exchanged': '已兑奖'
}
const prizeTimeValueMap = {
  'exchanging': 'addTime',
  'no_exchange': 'addTime',
  'expired': 'addTime',
  'exchanged': 'exchangeTime'
}
const prizeTimeLabelMap = {
  'exchanging': '中奖时间',
  'no_exchange': '中奖时间',
  'expired': '中奖时间',
  'exchanged': '兑奖时间'
}
class UdeskSlde extends React.Component {
  constructor (props) {
    super(props)
    const shopping = getParmUrl('shopping')

    this.state = {
      isWxwork: false,
      isAddingMobile: false,
      activeKey: 'userInfo',
      memberInfo: {},
      brandName: '',
      extraMobiles: [],
      userid: '',
      prizeUserInfo: {},
      prizeList: null,
      pageLoading: false,
      orderCodes: [],
      isEditingOrderCode: false,
      orderDatas: []
    }
  }
  // 初始化组件
  componentDidMount () {
    let brandId = getParmUrl('brandId')
    this.requestedUserId = getParmUrl('userId')

    let unionId = getParmUrl('unionId')

    if (unionId) {
      this.setState({ brandId, unionId, activeKey: getParmUrl('tab') || 'userInfo' }, () => {
        this.getUserInfo((res) => this.requestedUserId = res)
      })
    } else {
      message.error('未获取用户信息')
    }

    const wxVersion = getWxworkVersion() || getParmUrl('ismock')
    this.fetchGetUtmCampaign()
    if (wxVersion) {
      this.initWxwork()
      this.getuserConfig()
      this.setState({ isWxwork: true })
    }
  }
  initWxwork = async () => {
    try {
      const brandId = getParmUrl('brandId')
      const {status, data} = await ajaxApi(`${common.javaBase_url}brandwx/enterprisewx/getsdk`, {
        url: window.location.href.split('#')[0],
        brandId: brandId,
        agentCode: 'SIDE'
      }, () => {}, common.noLoginToken)
      if (status !== 200 || !data) {
        return
      }

      const config = {
        corpid: data.appId,
        agentid: data.agentId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['sendChatMessage'],
        success: () => {
          wx.checkJsApi({
            jsApiList: ['sendChatMessage'],
            success: res => {
              if (res.errMsg === 'checkJsApi:ok') {
                if (!res.checkResult.sendChatMessage) {
                  message.warn('您当前的企微版本不支持发送消息功能，如有需要请升级版本')
                }
              } else {
                message.error(`Call wx.checkJsApi failed${JSON.stringify(res)}`)
              }
            }
          })
        },
        fail: res => {
          console.error(res)
          message.warn(`wxJSApi 初始化失败(${res.err_msg || JSON.stringify(res)})`)
        }
      }
      // eslint-disable-next-line no-undef
      wx.agentConfig(config)
    } catch (e) {
      message.error(e.message)
      console.error(e)
    }
  }
  fetchGetUtmCampaign=async () => {
    const data = await getUtmCampaign({brand_id: getParmUrl('brandId')})
    if (data) {
      this.setState({brandName: data})
    }
  }
  validateMobile = (mobile) => {
    if (!mobile) {
      message.error('请输入手机号')
      return false
    }
    if (!mobileReg.test(mobile)) {
      message.error('请输入正确格式手机号')
      return false
    }
    return true
  }
  changeTab = (e) => {
    this.setState({activeKey: e})

    if (e === 'userInfo') {
      this.getUserInfo()
    } else if (e === 'prize') {
      this.getUserPrizeList()
    }
  }
  showConfirm = (giftItem) => () => {
    confirm({
      icon: <Icon type="exclamation-circle" />,
      title: '',
      content: '点击后，将标记已兑奖，是否还要继续？',
      cancelText: '取消',
      okText: '继续',
      onOk: () => {
        this.convertPrize(giftItem)
      },
      onCancel () { }
    })
  }
  // 运营兑换奖品
  convertPrize = async (giftitem = {}) => {
    try {
      const {prizeUserInfo} = this.state
      const params = {
        refId: giftitem.refId,
        userId: prizeUserInfo.userId,
        status: 'exchanged'
      }
      const res = await ajaxApi(`${common.javaBase_url}brandwx/luckydraw/exchange-gift`, params, () => { }, common.noLoginToken)

      if (res.status === 200) {
        this.getUserPrizeList()
      }
    } catch (error) {
      console.log(error)
    }
  }
  getOrderCodes = async (userId) => {
    try {
      const res = await ajaxApi(`${common.javaBase_url}brandwx/user/order/get-orders`, {userId}, () => {
      }, common.noLoginToken)
      if (res.status === 200) {
        const _data = _.get(res, 'data')
        if ((_data || []).length === 0) {
          return
        }
        const orderCodes = (_data || []).map(item => (item || {}).orderCode)
        this.setState({orderDatas: _data, orderCodes: orderCodes})
        this.addeOrderCode = orderCodes[0]
      }
    } catch (err) {
      console.log(err)
    }
  }
  saveOrderCode = async () => {
    // /brandwx/user/order/add
    const {orderDatas, unionId, userId, orderCodes} = this.state
    let params = {
      unionId,
      userId,
      orderCode: this.addeOrderCode
    }
    let requestApi = `${common.javaBase_url}brandwx/user/order/add`
    if (orderCodes.length) {
      requestApi = `${common.javaBase_url}brandwx/user/order/update`
      params.refId = (orderDatas[0] || {}).refId
    }
    try {
      const res = await ajaxApi(requestApi, params, () => {
      }, common.noLoginToken)
      if (res.status === 200) {
        this.getOrderCodes(userId)
        this.switchOrderCodeMode()
      }
    } catch (err) {
      console.log(err)
    }
  }

   addPhoneNumber = async () => {
     try {
       if (!this.validateMobile(this.addedNumber)) {
         return
       }
       const {memberInfo} = this.state
       const params = {
         phone: this.addedNumber,
         unionId: memberInfo.unionId,
         brandId: memberInfo.brandId,
         userId: memberInfo.userId
       }
       const res = await ajaxApi(`${common.javaBase_url}brandwx/user/add-phone`, params, () => { }, common.noLoginToken)

       if (res.status === 200) {
         this.changeToAddMode()
         this.getUserInfo()
       }
     } catch (error) {
       console.log(error)
     }
   }
   removePhoneNumber = async (item) => {
     const {memberInfo} = this.state
     try {
       const params = {
         phone: (item || {}).mobile,
         unionId: memberInfo.unionId,
         brandId: memberInfo.brandId,
         refId: item.refId
       }
       const res = await ajaxApi(`${common.javaBase_url}brandwx/user/del-phone`, params, () => { }, common.noLoginToken)

       if (res.status === 200) {
         this.getUserInfo()
       }
     } catch (error) {
       console.log(error)
     }
   }
   updatePhoneNumber = async (item) => {
     try {
       if (!this.validateMobile((item || {}).mobile)) {
         return
       }
       const {memberInfo} = this.state
       const params = {
         phone: (item || {}).mobile,
         unionId: memberInfo.unionId,
         brandId: memberInfo.brandId,
         refId: item.refId
       }
       const res = await ajaxApi(`${common.javaBase_url}brandwx/user/update-phone`, params, () => { }, common.noLoginToken)

       if (res.status === 200) {
         this.getUserInfo()
       }
     } catch (error) {
       console.log(error)
     }
   }

  getUserPrizeList = async () => {
    let { memberInfo } = this.state
    const params = {
      userBaseInfo: {
        phone: memberInfo.phone,
        brandId: memberInfo.brandId,
        unionId: memberInfo.unionId,
        userId: memberInfo.userId
      }
    }

    try {
      const res = await ajaxApi(`${common.javaBase_url}brandwx/luckydraw/query-gifts`, params, () => { }, common.noLoginToken)
      // const res = await ajaxApi(`http://192.168.30.85:8090/exchangeuser/user/prize-list`, { username }, () => { }, common.noLoginToken)
      if (res.status === 200) {
        this.setState({ prizeList: _.get(res, 'data.brandUserGiftInfos') || [] })
        this.setState({prizeUserInfo: _.get(res, 'data.userBaseInfo')})
      }
    } catch (error) {
      console.log(error)
    }
  }
  // 获取用户信息
  getUserInfo = async (cb) => {
    const {brandId, unionId} = this.state
    try {
      const res = await ajaxApi(`${common.javaBase_url}brandwx/user/get-userinfo-unionid`, {userId: this.requestedUserId, brandId, unionId }, () => { }, common.noLoginToken)

      if (res.status === 200) {
        this.setState({ memberInfo: res.data || {}, userId: (res.data || {}).userId })
        const mobileInfos = ((res.data || {}).brandUserPhoneInfos || []).filter(item => item.phone !== (res.data || {}).phone)
        if (res.data.userId) {
          if (!this.requestedUserId) {
            cb && cb(res.data.userId)
            this.getUserInfo((res) => {
              this.requestedUserId = res
            })
            return
          } else {
            this.getOrderCodes(res.data.userId)
          }
          this.addStatusToMobilesOfServer(mobileInfos)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  addStatusToMobilesOfServer = (data) => {
    let mobileWithStatusObjs = [];
    (data || []).forEach((item, index) => {
      mobileWithStatusObjs.push({...item, id: index + 1, mobile: item.phone, isEditing: false})
    })
    this.setState({extraMobiles: mobileWithStatusObjs})
  }
  changeToAddMode =() => {
    this.setState(prev => ({...prev, isAddingMobile: !prev.isAddingMobile}))
  }
  getWrapName = (name, type = '') => {
    if (name && type === 'time') {
      return moment(name).format('YYYY-MM-DD')
    }
    return name || '--'
  }
  onAddedNumberInput = e => {
    this.addedNumber = e.target.value
  }
  changeToMobileEditMode = (item) => () => {
    const { extraMobiles} = this.state
    extraMobiles.forEach(_item => {
      if (item.id === _item.id) {
        _item.isEditing = !_item.isEditing
      } else {
        _item.isEditing = false
      }
    })
    this.setState({extraMobiles})
  }
  switchOrderCodeMode = () => {
    this.setState(prev => ({...prev, isEditingOrderCode: !prev.isEditingOrderCode}))
  }
  confirmDelete = (item) => () => {
    confirm({
      icon: <Icon type="exclamation-circle" />,
      title: '',
      content: '是否确认删除该手机号？',
      cancelText: '取消',
      okText: '确认',
      onOk: () => {
        this.removePhoneNumber(item)
      },
      onCancel () { }
    })
  }
  onMobileEditDone = (item) => () => {
    this.updatePhoneNumber(item)
    this.changeToMobileEditMode(item)
  }

  onAddedOrderCodeInput = (e) => {
    this.addeOrderCode = e.target.value
  }

  renderOrderCodes = () => {
    const {orderCodes, isEditingOrderCode, userId} = this.state
    const operations = <span>
      <Icon type='edit' onClick={this.switchOrderCodeMode} />
    </span>

    return isEditingOrderCode
      ? <div className={styles.flexLeftRow}>
        <Input className={styles.inputSize} defaultValue={orderCodes.length ? orderCodes[0] : ''} onChange={this.onAddedOrderCodeInput}/>
        <Button
          className={classnames([styles.marginLefe8, styles['mini-btn']])}
          type="ghost"
          onClick={this.saveOrderCode}>完成</Button>
      </div> : <div>{orderCodes.length ? orderCodes[0] : '--'}{userId && operations}</div>
  }

  renderUserMobileArea = () => {
    const {memberInfo, extraMobiles, isAddingMobile} = this.state
    const operations = (item) => <span>
      <Icon type='edit' onClick={this.changeToMobileEditMode(item)} />

      <Icon className={styles.marginLefe8} type='delete' onClick={this.confirmDelete(item)} />
    </span>
    return memberInfo.phone ? <div>
      <div className={classnames([styles.flexLeftRow, styles.marbom4])}>{memberInfo.phone}<Button className={classnames([styles['mini-btn'], styles.marginLefe8]) } type='primary' onClick={this.changeToAddMode}
        style={isAddingMobile ? {opacity: 0.5, pointerEvents: 'none'} : {}}>新增</Button>
      </div>
      {extraMobiles.map(item => <div>{item.isEditing ? <div className={classnames([styles.flexLeftRow, styles.marbom4])}>
        <Input maxLength={11} className={styles.inputSize} onChange={(e) => item.mobile = e.target.value} defaultValue={item.mobile} />
        <Button className={classnames([styles.marginLefe8, styles['mini-btn']])} type='ghost' onClick={this.onMobileEditDone(item)}>完成</Button></div> : <div className={styles.marbom4}>{item.mobile} {operations(item)}</div>}</div>)}
      {isAddingMobile && <div className={styles.flexLeftRow}><Input maxLength={11} className={styles.inputSize} onChange={this.onAddedNumberInput} /> <Button className={classnames([styles.marginLefe8, styles['mini-btn']]) } type="ghost" onClick={this.addPhoneNumber}>完成</Button></div>}
    </div> : '--'
  }
  logout () {
    clearCookie('login_password')
    clearCookie('login_username')
    localStorage.removeItem('token')
    localStorage.removeItem('utm_campaign')
    setTimeout(() => {
      window.location.href = '/login'
    }, 500)
  }
  getuserConfig = async () => {
    const res = await ajaxApi(`${common.new_net_to_java}sidebar/user-config-list`, {
      user_name: '',
      belong_to: 'brand',
      utm_campaign: '',
      page_index: 0,
      page_size: 100
    })
    const loginUsername = getCookie('login_username')
    if (res && res.data) {
      const accountList = res.data.data || []
      const accountOptions = accountList && accountList.length ? accountList.map((account) => {
        return {
          label: account.name,
          value: account.utm_campaign
        }
      }) : []
      this.setState({
        accountOptions
      }, () => {
        const defaultAccount = accountOptions.find(account => account.label === loginUsername)
        if (defaultAccount) {
          this.setState({
            utm_campaign: defaultAccount.value
          })
          localStorage.setItem('utm_campaign', defaultAccount.value)
        } else {
          message.warn('请选择运营人员')
        }
      })
    }
  }
  render () {
    const { activeKey, memberInfo, prizeList, pageLoading, brandName, utm_campaign, accountOptions, isWxwork } = this.state
    const loginUsername = getCookie('login_username')
    const brandId = getParmUrl('brandId')
    return (
      <Spin spinning={pageLoading}>
        <div className={classnames([styles.accountContainer])}>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '80px' }}>账号</div>
            <div style={{ width: '160px' }}>{loginUsername}</div>
            <Button type='link' onClick={this.logout} style={{ color: '#00B38B' }}>退出</Button>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '80px' }}>运营人员</div>
            <Select
              style={{ width: '160px' }}
              placeholder="请选择"
              value={utm_campaign}
              onChange={(v) => {
                this.setState({
                  utm_campaign: v
                })
                localStorage.setItem('utm_campaign', v)
              }}
              showSearch
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {
                (accountOptions || []).map((option) => {
                  return <Select.Option key={option.value}>{option.label}</Select.Option>
                })
              }
            </Select>

          </div>
        </div>
        <div className={ classnames([styles.udekCustomerService]) }>
          <ProductSearchbar brandName={brandName} brandId={brandId}></ProductSearchbar>
          <Tabs type='card' tabPosition={ 'left' } activeKey={ activeKey } onChange={ this.changeTab }>
            <TabPane tab="会员" key="userInfo">
              <div style={{padding: '0 20px'}}>
                <div className={ classnames([styles.marbom4, styles.flexLeftRow]) }><div>授权时间：</div><div>{this.getWrapName(memberInfo.addTime, 'time') }</div></div>
                <div className={classnames([styles.marbom4, styles.flexLeftRow])}><div>unid：</div><div style={{width: '66vw'}} className={styles.onelinedot}>{ this.getWrapName(memberInfo.unionId) }</div></div>
                <div className={classnames([styles.marbom4, styles.flexLeftRow])}>
                  <div style={{whiteSpace: 'nowrap'}}>手机号：</div>
                  {
                    this.renderUserMobileArea()
                  }
                </div>
                <div className={classnames([styles.marbom4, styles.flexLeftRow])}>
                  <div style={{whiteSpace: 'nowrap'}}>抽奖订单编码：</div>
                  {
                    this.renderOrderCodes()
                  }
                </div>
              </div>
            </TabPane>
            <TabPane tab="奖品" key="prize">
              {
                prizeList
                  ? prizeList.length > 0 ? (
                    <div className={styles.prizeList}>
                      {
                        prizeList.map((dataItem, index) => (
                          <div key={index} className={classnames([styles.flexLeftRow, styles.prizeContainer])}>
                            <img className={styles.prizeImage} src={dataItem.giftLittlePicUrl} alt=""/>
                            <div style={{justifyContent: 'space-around'}} className={classnames([styles.prizeContent, styles.flexBetweenColumn])}>
                              <div>{dataItem.giftName}</div>
                              <div>1件</div>
                              <div>奖品暗号：{dataItem.cipher === null || dataItem.cipher === '请联系客服人工处理!' ? '' : dataItem.cipher}</div>
                              <div style={{width: '100%', textAlign: 'right' }}>
                                {dataItem.status === 'no_exchange' ? <Button className={styles['mini-btn']} type="primary" onClick={this.showConfirm(dataItem)}>未兑奖</Button> : <span style={{color: '#a19b9b'}}>{prizeStatusMap[dataItem.status]}</span>}
                              </div>
                              <div>{(prizeTimeLabelMap[dataItem.status] || '中奖时间')}：{moment(dataItem[(prizeTimeValueMap[dataItem.status] || 'addTime')]).format('YYYY-MM-DD')}</div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  ) : <Empty description="没有相关记录" /> : null
              }
            </TabPane>
            <TabPane tab="订单" key="order">
              <OrderTabItem memberInfo={memberInfo} brandName={brandName}></OrderTabItem>
            </TabPane>
            <TabPane tab="活动" key="activity" >
              <ActivityTabItem isWxwork={isWxwork} brandName={brandName} brandId={brandId} />
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    )
  }
}
export default UdeskSlde



// WEBPACK FOOTER //
// ./src/pages/udeskSide/udeskSide.js